import { Popover, Tag } from 'antd'
import { isValidArray } from '../../utils/helpers'
import styles from '../../testrun.module.css'

const MAX_TABLE_TAGS = 2

function TagPopoverContent({ tags }) {
    return (
        <div className={styles.tagPopoverContent}>
            {tags.map((tag) => (
                <Tag key={tag?._id || tag?.name} className={styles.tagPopoverItem}>
                    {tag?.name || 'N/A'}
                </Tag>
            ))}
        </div>
    )
}

const TagChipsCell = ({ tags, wrap = false }) => {
    if (!isValidArray(tags) || tags.length === 0) {
        return <span className={styles.tagCellEmpty}>—</span>
    }

    if (wrap) {
        return (
            <div className={styles.tagChipsWrap}>
                {tags.map((tag) => (
                    <Tag
                        key={tag?._id || tag?.name}
                        className={styles.tagTableChip}
                    >
                        {tag?.name || 'N/A'}
                    </Tag>
                ))}
            </div>
        )
    }

    const visible = tags.slice(0, MAX_TABLE_TAGS)
    const hiddenCount = tags.length - visible.length
    const needsPopover = tags.length > 1

    const cell = (
        <div className={styles.tagTableCell}>
            <div className={styles.tagTableStack}>
                {visible.map((tag) => (
                    <Tag
                        key={tag?._id || tag?.name}
                        className={styles.tagTableChip}
                        title={tag?.name || 'N/A'}
                    >
                        <span className={styles.tagTableChipText}>
                            {tag?.name || 'N/A'}
                        </span>
                    </Tag>
                ))}
            </div>
            {hiddenCount > 0 && (
                <span className={styles.tagTableMore}>+{hiddenCount} more</span>
            )}
        </div>
    )

    if (!needsPopover) return cell

    return (
        <Popover
            content={<TagPopoverContent tags={tags} />}
            title={`${tags.length} tag${tags.length !== 1 ? 's' : ''}`}
            trigger="hover"
            placement="topLeft"
            overlayClassName={styles.tagPopoverOverlay}
        >
            <div className={styles.tagTableCellInteractive}>{cell}</div>
        </Popover>
    )
}

export default TagChipsCell
